import { render, staticRenderFns } from "./ScreeningEventLogItem.vue?vue&type=template&id=642c8da8&scoped=true&"
import script from "./ScreeningEventLogItem.vue?vue&type=script&lang=js&"
export * from "./ScreeningEventLogItem.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningEventLogItem.vue?vue&type=style&index=0&id=642c8da8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642c8da8",
  null
  
)

export default component.exports